// extracted by mini-css-extract-plugin
export const netsFilters = "NetsFilters-module__nets-filters--EvmOX";